import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetSubscriptionPlansResponse,
  PostSubscriptionRequest,
  PostSubscriptionResponse,
} from './models';
import { SUBSCRIPTION_TAGS, USER_TAGS } from '../../tags';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

export const subscriptionApi = createApi({
  reducerPath: SUBSCRIPTION_TAGS.SUBSCRIPTION,
  baseQuery: baseQueryWithReauth,
  tagTypes: [SUBSCRIPTION_TAGS.SUBSCRIPTION, USER_TAGS.USER],
  endpoints: (build) => ({
    //ASAP TO FIX AT BE - card id needed at request
    postSubscription: build.mutation<PostSubscriptionResponse, void>({
      query: () => {
        return {
          method: 'POST',
          url: `/subscription`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
      invalidatesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION],
    }),
    deleteSubscription: build.mutation<any, { id: number }>({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `/subscription/${id}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION],
    }),
    resumeSubscription: build.mutation<any, { id: number }>({
      query: ({ id }) => ({
        method: 'POST',
        url: `/subscription/${id}/resume`,
        headers: {
          Accept: 'application/json',
        },
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION, USER_TAGS.USER],
    }),
    // the wire-transfer payer's opt-in: renew out of the account balance
    updateSubscriptionRenewFromBalance: build.mutation<
      unknown,
      { id: number; renew_from_balance: boolean }
    >({
      query: ({ id, renew_from_balance }) => ({
        method: 'PATCH',
        url: `/subscriptions/${id}/renew-from-balance`,
        body: { renew_from_balance },
      }),
      invalidatesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION, USER_TAGS.USER],
    }),
    getSubscriptionPlans: build.query<GetSubscriptionPlansResponse, void>({
      query: () => ({
        url: '/subscriptions/outreach',
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
        providesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION],
      }),
    }),
    getSubscriptionToAnnualPlan: build.query<GetSubscriptionPlansResponse, { isAnnual: boolean }>({
      query: ({ isAnnual }) => ({
        url: `/subscriptions/outreach?annual=${Number(isAnnual)}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
        providesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION],
      }),
    }),
    postUpdateSubscriptionById: build.mutation<PostSubscriptionResponse, PostSubscriptionRequest>({
      query: ({ id, data }) => {
        return {
          method: 'POST',
          url: `/subscriptions/${id}`,
          body: data,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
      invalidatesTags: [SUBSCRIPTION_TAGS.SUBSCRIPTION, USER_TAGS.USER],
    }),
  }),
});

export const {
  usePostSubscriptionMutation,
  useDeleteSubscriptionMutation,
  useResumeSubscriptionMutation,
  useUpdateSubscriptionRenewFromBalanceMutation,
  useGetSubscriptionPlansQuery,
  useGetSubscriptionToAnnualPlanQuery,
  usePostUpdateSubscriptionByIdMutation,
} = subscriptionApi;
